import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Alert, Box, Button, CircularProgress, Dialog, Typography } from '@mui/material'
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import { SIGN_OUT_EVERYWHERE } from './SignInsDialog'
import { sessionUserId } from '../../utils/authToken'

// "Sign out of all devices" from the sidebar's account menu: ends every
// session of the signed-in account, this one included (backend migration
// 137), then logs this device out the usual way via onSignedOut.
export default function SignOutAllDevicesDialog({ open, onClose, onSignedOut }) {
  const [failed, setFailed] = useState('')
  const [signOut, { loading }] = useMutation(SIGN_OUT_EVERYWHERE, {
    onCompleted: () => {
      onClose()
      onSignedOut()
    },
    onError: err => setFailed(err.message)
  })

  const close = () => {
    if (loading) return
    setFailed('')
    onClose()
  }

  const confirm = () => {
    const vendorId = sessionUserId()
    setFailed('')
    if (!vendorId) {
      onClose()
      onSignedOut()
      return
    }
    signOut({ variables: { vendorId: String(vendorId) } })
  }

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: '20px' } }}>
      <Box sx={{ p: 3 }}>
        <Box sx={{ width: 44, height: 44, borderRadius: '12px', bgcolor: '#fef2f2', color: '#dc2626', display: 'grid', placeItems: 'center', mb: 2 }}>
          <DevicesRoundedIcon />
        </Box>
        <Typography sx={{ fontWeight: 800, fontSize: '1.15rem', color: '#0f172a' }}>
          Sign out of all devices?
        </Typography>
        <Typography sx={{ fontSize: '0.875rem', color: '#64748b', mt: 0.75 }}>
          Your account is signed out everywhere it is signed in, including other browsers, phones and tablets, and this one. You will need to sign in again.
        </Typography>
        {failed && <Alert severity="error" sx={{ mt: 2 }}>{failed}</Alert>}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' }, justifyContent: 'flex-end', gap: 1, mt: 3 }}>
          <Button onClick={close} disabled={loading} sx={{ textTransform: 'none', color: '#475569', fontWeight: 600 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            disabled={loading}
            onClick={confirm}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <LogoutRoundedIcon />}
            sx={{ bgcolor: '#dc2626', textTransform: 'none', fontWeight: 700, borderRadius: '10px', '&:hover': { bgcolor: '#b91c1c' } }}
          >
            Sign out everywhere
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
